export default __webpack_public_path__ + "static/media/Samsuung.3eff37d4.svg";